<script>
    import EmailStat from './components/EmailStat.vue';
    import EmailPreview from './components/EmailPreview.vue';
    export default {
        name: 'EmailApp',
        components: {'stat': EmailStat, 'email-preview': EmailPreview}, 
        data: function() {
            return {
                htmlstring: null,
                stat: null,
                previewStat: null,
                ids: [],
                siteId: null,
            }
        },
        watch: {
        },
        mounted: function() {
            let ap = this;

            this.ids = JSON.parse(this.$refs.schedules.dataset.ids);
            this.siteId = this.$refs.schedules.dataset.siteid;

            $.ajax({
                type: "POST",
                url: '/schedules/'+this.siteId+'/stat/',
                data: {ids: ap.ids}, 
                success: function ( data ) {
                    if (data.stat) {
                        ap.stat = data.stat;
                    }
                },
                error: function(error) {
                    console.log('Ошибка при загрузке статистики');
                    return;
                }
            });
        },
        methods: {
            showPreview: function(siteId, scheduleId) {
                let ap = this;
                $.ajax({
                    type: "GET",
                    url: '/schedules/'+siteId+'/'+scheduleId+'/view/',
                    success: function ( htmldata ) {
                        if (htmldata.html) {
                            ap.htmlstring = htmldata.html;
                            $.ajax({
                                type: "GET",
                                url: '/schedules/'+siteId+'/'+scheduleId+'/stat/',
                                success: function ( data ) {
                                    if (data.stat && ap.htmlstring) {
                                        let html = $(htmldata.html);
                                        let links = html.find('a[href*="utm_content"]');
                                        for (let link of links) {
                                            let utmContent = new URLSearchParams(link.href).get('utm_content');
                                            let linkStat = data.stat[utmContent];
                                            if (linkStat) {
                                                $(link).css({'position': 'relative'});
                                                link.innerHTML = link.innerHTML+ `
                                                    <div style="font-size: 12px; position: absolute; background-color: #dddddd; z-index: 100; top: 100%; min-width: 70px; padding: 5px; border-radius: 5px;margin-top: 15px; left: 50%; margin-left: -35px; opacity: 0.9; max-width: 70px;">
                                                        <div style="width: 0; height: 0; border-style: solid; border-width: 0 5px 10px 5px; border-color: transparent transparent #dddddd transparent; position: absolute; margin-top: -15px; left: 50%; margin-left: -5px;opacity: 0.9;"></div>
                                                        <div style="color: #000000; font-size: 10px; line-height: 14px; text-align: right;">
                                                            <span class="fa fa-mouse-pointer float-left" style="line-height: 14px;"></span>
                                                            `+linkStat.users+`
                                                        </div>
                                                        <div style="color: #000000; font-size: 10px; line-height: 14px; text-align: right;">
                                                            <span class="fa fa-shopping-cart float-left" style="line-height: 14px;"></span>
                                                            `+linkStat.transactions+`
                                                        </div>
                                                        <div style="color: #000000; font-size: 10px; line-height: 14px; text-align: right;">
                                                            <span class="fa fa-money float-left" style="line-height: 14px;"></span>
                                                            `+Math.round(linkStat.revenue)+` 
                                                        </div>
                                                    </div>
                                                `;
                                            }
                                        }
                                        ap.previewStat = data.stat;
                                        ap.htmlstring = html[0].outerHTML;
                                    }
                                },
                                error: function(error) {
                                    console.log('Ошибка при получении статистике по рассылке');
                                    return;
                                }
                            });
                        }
                    },
                    error: function(error) {
                        console.log('Ошибка при загрузке рассылки');
                        return;
                    }
                });
            },
            close: function() {
                this.htmlstring = null;
                this.previewStat = null;
            },
        }
    }
</script>
